"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
var facets_1 = require("../immutable/facets");
var immutable_1 = require("immutable");
// 0.0014s overhead
exports.patchFacets = function (facets, updater) {
    return facets
        && facets.map(function (facet) { return new facets_1.Facet(facet, updater); })
        || immutable_1.Map();
};
/**
 * Used to connect to facets field of Search API response and transform it into
 * internal MJS structure
 */
var _a = createConnect_1.default({
    field: 'facets',
    mapProps: function (facets, _, update) { return ({
        facets: exports.patchFacets(facets, update)
    }); }
}), hook = _a[0], connect = _a[1];
exports.hook = hook;
exports.connect = connect;
//# sourceMappingURL=connectFacets.js.map